import { render, staticRenderFns } from "./slector1.vue?vue&type=template&id=43313224&scoped=true&"
import script from "./slector1.vue?vue&type=script&lang=js&"
export * from "./slector1.vue?vue&type=script&lang=js&"
import style0 from "./slector1.vue?vue&type=style&index=0&id=43313224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43313224",
  null
  
)

export default component.exports